import React from 'react'

import './Content.scss'

export interface PageContentProps {
  children: React.ReactNode
}

const PageContent = React.memo(({ children }: PageContentProps) => {
  return <div className="PageContent">{children}</div>
})

PageContent.displayName = 'Page.Content'

export default PageContent
